import { ModelInstance, BaseModel, ToBackHook, ToFrontHook } from './util';
import { RugbyStatistic } from './rugby-statistic';
import { GameTeamStatisticBase } from './game-team-statistic-base';

@ModelInstance({
  mappingFields: {
    team: 'team',
    competitor_team: 'competitorTeam'
  },
  relation: {
    team: RugbyStatistic,
    competitorTeam: RugbyStatistic
  }
})
export class RugbyGameTeamStatistic extends BaseModel implements GameTeamStatisticBase {
  team: RugbyStatistic;
  competitorTeam: RugbyStatistic;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
